import { useQuery } from "@tanstack/react-query";
import { adminGetModuleContentByModuleId } from "../queries";
import { IAssignedModule, IAssignedTask } from "../../../types/generalTypes";
import NotAssignedTaskItem from "./NotAssignedTaskItem";

// module_cohort_id, content_type, content_id, planning_date

export default function ContentsToAssign({
  openedModule,
  shouldFetch,
}: {
  shouldFetch: boolean;
  openedModule: undefined | IAssignedModule;
}) {
  const { data: moduleContentList, isSuccess } = useQuery(
    adminGetModuleContentByModuleId({
      moduleId: openedModule?.module_id,
      enabled: shouldFetch,
    })
  );


  return (
    isSuccess && shouldFetch && <div className="panel rounded-3xl border border-myGb/40 p-8">
      <h2 className="text-xl">{openedModule?.title} <span className="text-white/60">(id: {openedModule?.module_id})</span></h2>
      {moduleContentList?.map((task: IAssignedTask) => (
        <NotAssignedTaskItem key={task.tag + task.id} item={task} mcId={openedModule?.module_cohort_id} />
      ))}
    </div>
  );
}
